import React from "react";
import { BillingBox } from "../BillingBox/BillingBox";
import { LoadingBox } from "../../shared/LoadingBox/LoadingBox";
import { SubscriptionBox } from "../SubscriptionBox/SubscriptionBox";
import { HandleRequestState } from "../../shared/HandleRequestState/HandleRequestState";
import { useSubscription } from "../../../lib/hooks/useSubscription";
import { usePartnerData } from "../../Billings/lib/usePartnerData";
import { useCustomerRequests } from "../../../api/grpc/customer/useCustomerRequests";
import { CustomerSettings } from "../../../api/grpc/customer/customer";
import useGrpcQuery from "../../../lib/hooks/useGrpcQuery";

import "./SubscriptionWrapper.scss";

export const SubscriptionWrapper = () => {
  const { loading, error, data } = useSubscription();
  const { data: partnerData } = usePartnerData();
  const { getCustomerSettings } = useCustomerRequests();
  const { data: customerSettings } = useGrpcQuery<{}, CustomerSettings>({
    method: getCustomerSettings,
    variables: {},
  });
  const hasCrossOrgCalendarEntitlement =
    !!customerSettings?.crossOrgRoomCalendarEnabled;

  return (
    <div className="SubscriptionWrapper">
      <HandleRequestState
        state={loading}
        placeholder={
          <>
            <div
              className="SubscriptionWrapper__loading"
              aria-label="Loading subscriptions"
              aria-busy="true"
            >
              <LoadingBox minHeight={195} />
            </div>
            <div
              className="SubscriptionWrapper__loading"
              aria-label="Loading billing"
              aria-busy="true"
            >
              <LoadingBox minHeight={195} />
            </div>
          </>
        }
      >
        <HandleRequestState
          state={!!error}
          placeholder={
            <div
              className="default-box SubscriptionWrapper__error"
              role="alert"
            >
              <p>Error loading subscription information</p>
            </div>
          }
        >
          <SubscriptionBox
            data={data?.subscription}
            hasCrossOrgCalendarEntitlement={hasCrossOrgCalendarEntitlement}
          />
          {!partnerData?.email && (
            <BillingBox
              data={data?.billing}
              status={data?.subscription?.status?.toLowerCase()}
            />
          )}
        </HandleRequestState>
      </HandleRequestState>
    </div>
  );
};
